import { CUSTOM_ELEMENTS_SCHEMA, NgModule,ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AgGridModule } from 'ag-grid-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { QuillModule } from 'ngx-quill'

import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

import { MatIconModule } from '@angular/material/icon';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { HeaderComponent } from './layouts/full/header/header.component';
import { BrandingComponent } from './layouts/full/sidebar/branding.component';
import { AppNavItemComponent } from './layouts/full/sidebar/nav-item/nav-item.component';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth-service/auth.service';
import { AuthGuard } from './services/auth-service/auth-guard.service';
import { ToastrModule } from 'ngx-toastr';
import { CustomToastComponent } from './pages/custom-toast/custom-toast.component';

import { registerLocaleData } from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';
import { TracingInterceptor } from './interceptors/tracing.interceptor';
import { TraceLogService } from './services/trace-log.service';
import { TraceLogFlushService } from './services/trace-log-flush.service';
import { ErrorsHandler } from './services/error-handler'; 
import { CorrelationInterceptor } from './correlation/correlation.interceptor';
import { AuthInterceptor } from './interceptors/Auth.interceptor';



registerLocaleData(localeIn);

@NgModule({ declarations: [
        AppComponent,
        FullComponent,
        BlankComponent,
        SidebarComponent,
        HeaderComponent,
        BrandingComponent,
        AppNavItemComponent,

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AgGridModule,
        AppRoutingModule,
        FontAwesomeModule,
        MatIconModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        NgxExtendedPdfViewerModule,
        MatTableModule,
        MatPaginatorModule,QuillModule.forRoot(), 
   ToastrModule.forRoot({
  timeOut: 10000,
  positionClass: 'toast-bottom-right',
  preventDuplicates: true,
  toastComponent: CustomToastComponent, 
}),], providers: [ApiService, AuthService, AuthGuard,TraceLogService,
    TraceLogFlushService,ErrorsHandler, provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: TracingInterceptor, multi: true },
    { provide: ErrorHandler, useClass: ErrorsHandler },
    { provide: HTTP_INTERCEPTORS, useClass: CorrelationInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
] })
export class AppModule {}
